import { createContext, type Dispatch, type ReactNode, type SetStateAction, useState } from 'react'
import type { PrimaryAction } from './types'

// The bottom nav's center button is a single page-driven slot: the active page registers its primary
// action and clears it on unmount. Read and write are split into two contexts so pages that only SET the
// action don't re-render every time its value changes.
export const PrimaryActionValueContext = createContext<PrimaryAction | null>(null)
export const PrimaryActionSetContext = createContext<Dispatch<SetStateAction<PrimaryAction | null>> | undefined>(undefined)

export function PrimaryActionProvider({ children }: { children: ReactNode }) {
  const [action, setAction] = useState<PrimaryAction | null>(null)
  return (
    <PrimaryActionSetContext.Provider value={setAction}>
      <PrimaryActionValueContext.Provider value={action}>{children}</PrimaryActionValueContext.Provider>
    </PrimaryActionSetContext.Provider>
  )
}
